var _path, _rect, _path2, _polygon, _path3, _polygon2, _path4, _path5, _path6, _polygon3, _path7, _polygon4, _path8, _polygon5, _path9, _path0, _path1, _polygon6, _path10, _polygon7, _path11, _polygon8, _path12, _path13, _path14, _polygon9, _path15, _rect2, _path16, _rect3, _path17, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8CambodiaCircular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#d50000",
    d: "M39.973,12H8.027C5.51,15.345,4,19.491,4,24c0,4.509,1.51,8.655,4.027,12h31.946 C42.49,32.655,44,28.509,44,24C44,19.491,42.49,15.345,39.973,12z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 9.998,
    height: 3.996,
    x: 19.233,
    y: 22.75,
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M29.281,26.796H19.184V22.7h10.097V26.796z M19.283,26.696h9.898V22.8h-9.898V26.696z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "16.033,22.628 16.033,23.776 16.324,24.006 16.324,25.935 15.941,26.593 17.932,26.593 17.932,22.659"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M17.981,26.644h-2.127l0.42-0.722V24.03l-0.291-0.229v-1.224l1.998,0.032V26.644z M16.028,26.544 h1.854v-3.837l-1.799-0.028v1.073l0.291,0.229v1.968l-0.006,0.012L16.028,26.544z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "20.014,22.628 20.014,23.776 19.723,24.006 19.723,25.935 20.106,26.593 18.116,26.593 18.116,22.659"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M20.193,26.644h-2.127v-4.034l0.049-0.001l1.949-0.031v1.224l-0.291,0.229v1.892L20.193,26.644z M18.166,26.544h1.854l-0.346-0.595v-1.968l0.291-0.229v-1.073l-1.799,0.028V26.544z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18.942,25.813v-1.577l0.413-0.505v-2.159l-0.199,0.276l-0.245-0.168l0.214-0.398l-0.322-1.118 L18.56,20.5c0,0,0.046-0.061,0.031-0.521c-0.015-0.459-0.566-0.628-0.566-0.628s-0.551,0.168-0.566,0.628 c-0.015,0.459,0.031,0.521,0.031,0.521l-0.245-0.337l-0.322,1.118l0.214,0.398l-0.245,0.168l-0.199-0.276v2.159l0.413,0.505v1.577 l-0.444,0.781h1.363h1.363L18.942,25.813z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M19.472,26.644h-2.897l0.48-0.845v-1.546l-0.413-0.505v-2.331l0.261,0.361l0.167-0.115 l-0.203-0.377l0.006-0.02l0.35-1.216l0.184,0.254c-0.004-0.079-0.005-0.185,0-0.327c0.017-0.49,0.578-0.667,0.602-0.674 l0.015-0.005l0.015,0.005c0.024,0.007,0.585,0.184,0.602,0.674c0.005,0.143,0.004,0.248,0,0.327l0.184-0.254l0.355,1.235 l-0.203,0.377l0.168,0.115l0.261-0.361v2.331l-0.414,0.505v1.546L19.472,26.644z M16.747,26.544H19.3l-0.408-0.718v-1.608 l0.414-0.505v-1.987l-0.138,0.189l-0.322-0.221l0.226-0.42l-0.287-0.999L18.6,20.529c0,0,0,0,0,0.001l-0.081-0.06l0-0.001l0,0 c-0.001,0,0.034-0.082,0.021-0.488c-0.013-0.378-0.432-0.547-0.517-0.577c-0.084,0.03-0.504,0.199-0.517,0.577 c-0.013,0.41,0.022,0.49,0.024,0.493l-0.083,0.056c0-0.001,0-0.001,0-0.001l-0.185-0.254l-0.287,0.999l0.226,0.42l-0.323,0.221 l-0.137-0.189v1.987l0.413,0.505v1.608l-0.006,0.011L16.747,26.544z"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "18.483,23.96 18.927,23.409 18.223,20.117 18.024,19.872 17.825,20.117 17.12,23.409 17.564,23.96 17.564,25.889 17.212,26.609 18.024,26.609 18.835,26.609 18.483,25.889"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M18.915,26.658h-1.783l0.382-0.78v-1.9l-0.448-0.556l0.005-0.023l0.714-3.312l0.238-0.293 l0.248,0.313l0.709,3.315l-0.015,0.019l-0.434,0.537v1.9L18.915,26.658z M17.292,26.559h1.462l-0.322-0.669v-1.947l0.011-0.014 l0.43-0.532l-0.697-3.257l-0.152-0.188l-0.153,0.188l-0.697,3.257l0.44,0.546l-0.005,1.97L17.292,26.559z"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "28.006,22.628 28.006,23.776 28.297,24.006 28.297,25.935 27.914,26.593 29.905,26.593 29.905,22.659"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M29.955,26.644h-2.127l0.42-0.722V24.03l-0.291-0.229v-1.224l1.998,0.032V26.644z M28.001,26.544 h1.854v-3.837l-1.799-0.028v1.073l0.291,0.229v1.968l-0.006,0.012L28.001,26.544z"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "31.987,22.628 31.987,23.776 31.696,24.006 31.696,25.935 32.079,26.593 30.089,26.593 30.089,22.659"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M32.166,26.644h-2.127v-4.034l0.049-0.001l1.95-0.031v1.224l-0.291,0.229v1.892L32.166,26.644z M30.138,26.544h1.854l-0.346-0.595v-1.968l0.291-0.229v-1.073l-1.799,0.028V26.544z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M30.915,25.813v-1.577l0.413-0.505v-2.159l-0.199,0.276l-0.245-0.168l0.214-0.398l-0.322-1.118 L30.533,20.5c0,0,0.046-0.061,0.031-0.521c-0.015-0.459-0.566-0.628-0.566-0.628s-0.551,0.168-0.566,0.628 c-0.015,0.459,0.031,0.521,0.031,0.521l-0.245-0.337l-0.322,1.118l0.214,0.398l-0.245,0.168l-0.199-0.276v2.159l0.413,0.505v1.577 l-0.444,0.781h1.363h1.363L30.915,25.813z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M31.445,26.644h-2.897l0.48-0.845v-1.546l-0.414-0.505v-2.331l0.261,0.361l0.168-0.115 l-0.203-0.377l0.006-0.02l0.35-1.216l0.184,0.254c-0.004-0.079-0.005-0.185,0-0.327c0.016-0.49,0.578-0.667,0.602-0.674 l0.015-0.005l0.015,0.005c0.024,0.007,0.585,0.184,0.602,0.674c0.005,0.142,0.004,0.248,0,0.327l0.184-0.254l0.356,1.235 l-0.203,0.377l0.167,0.115l0.261-0.361v2.331l-0.413,0.505v1.546L31.445,26.644z M28.72,26.544h2.553l-0.408-0.718v-1.608 l0.413-0.505v-1.987l-0.137,0.189l-0.323-0.221l0.226-0.42l-0.288-0.999l-0.185,0.254c0,0,0,0,0,0.001l-0.081-0.06l0-0.001l0,0 c-0.001,0,0.034-0.082,0.021-0.488c-0.013-0.379-0.432-0.547-0.517-0.577c-0.084,0.03-0.504,0.199-0.517,0.577 c-0.013,0.41,0.022,0.49,0.024,0.493l-0.083,0.056c0-0.001,0-0.001,0-0.001l-0.185-0.254l-0.287,0.999l0.226,0.42l-0.322,0.221 l-0.138-0.189v1.987l0.414,0.505v1.608l-0.006,0.011L28.72,26.544z"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "30.456,23.96 30.9,23.409 30.196,20.117 29.997,19.872 29.798,20.117 29.093,23.409 29.537,23.96 29.537,25.889 29.185,26.609 29.997,26.609 30.808,26.609 30.456,25.889"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M30.888,26.658h-1.783l0.383-0.78v-1.9l-0.448-0.556l0.005-0.023l0.714-3.312l0.238-0.293 l0.248,0.313l0.709,3.315l-0.015,0.019l-0.433,0.537v1.9L30.888,26.658z M29.265,26.559h1.463l-0.322-0.669v-1.947l0.011-0.014 l0.429-0.532l-0.697-3.257l-0.153-0.188l-0.152,0.188l-0.697,3.257l0.44,0.546l-0.005,1.97L29.265,26.559z"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "21.45,21.452 21.45,22.94 21.827,23.237 21.827,25.736 21.331,26.589 23.909,26.589 23.909,21.492"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M23.959,26.639h-2.715l0.533-0.916v-2.461L21.4,22.964v-1.562l0.051,0.001l2.508,0.041V26.639z M21.418,26.539h2.441v-4.998l-2.36-0.038v1.412l0.377,0.298v2.537l-0.006,0.012L21.418,26.539z"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "26.604,21.452 26.604,22.94 26.227,23.237 26.227,25.736 26.723,26.589 24.145,26.589 24.145,21.492"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M26.81,26.639h-2.715v-5.195l0.049-0.001l2.51-0.041v1.562l-0.019,0.015l-0.358,0.283v2.461 L26.81,26.639z M24.194,26.539h2.441l-0.458-0.789v-2.537l0.019-0.015l0.358-0.283v-1.412l-2.36,0.038V26.539z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M25.215,25.577v-2.043l0.535-0.654v-2.796l-0.258,0.357l-0.317-0.218l0.278-0.516l-0.416-1.448 l-0.317,0.436c0,0,0.059-0.079,0.04-0.674c-0.019-0.583-0.704-0.804-0.731-0.812v-0.001c0,0-0.001,0-0.001,0c0,0-0.001,0-0.001,0 v0.001c-0.028,0.009-0.712,0.229-0.731,0.812c-0.02,0.595,0.04,0.674,0.04,0.674l-0.317-0.436L22.6,19.707l0.278,0.516 l-0.317,0.218l-0.258-0.357v2.796l0.535,0.654v2.043l-0.575,1.011h1.763h0.003h1.763L25.215,25.577z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M25.876,26.639h-3.699l0.611-1.075v-2.011l-0.535-0.655V19.93l0.319,0.442l0.24-0.165l-0.266-0.494 l0.006-0.02l0.445-1.547l0.25,0.345c-0.007-0.104-0.01-0.255-0.003-0.472c0.018-0.546,0.573-0.788,0.731-0.846v-0.015l0.1-0.001 l0.001,0.015c0.155,0.057,0.715,0.298,0.733,0.847c0.007,0.217,0.004,0.367-0.003,0.472l0.25-0.345l0.451,1.566l-0.01,0.018 l-0.256,0.477l0.24,0.165l0.319-0.442v2.968l-0.536,0.655v2.011L25.876,26.639z M22.349,26.539h3.355l-0.539-0.948v-2.073 l0.536-0.655v-2.624l-0.196,0.271l-0.395-0.271l0.29-0.537l-0.382-1.33l-0.257,0.354c0,0,0,0.001,0,0.001l-0.081-0.06l0-0.001 c0-0.001,0.048-0.104,0.03-0.642c-0.017-0.506-0.583-0.728-0.683-0.762c-0.099,0.034-0.666,0.256-0.683,0.762 c-0.018,0.541,0.03,0.642,0.032,0.646l-0.083,0.057c0,0,0-0.001,0-0.001l-0.257-0.354l-0.382,1.33l0.29,0.537l-0.395,0.271 l-0.196-0.271v2.624l0.535,0.655v2.073l-0.006,0.011L22.349,26.539z"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "24.621,23.178 25.196,22.464 24.283,18.2 24.028,17.885 24.028,17.882 24.027,17.884 24.026,17.882 24.026,17.885 23.77,18.2 22.858,22.464 23.433,23.178 23.433,25.677 22.977,26.609 24.026,26.609 24.028,26.609 25.077,26.609 24.621,25.677"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M25.157,26.658h-2.26l0.486-0.993v-2.47l-0.579-0.719l0.005-0.023l0.923-4.285l0.244-0.3v-0.133 l0.051,0.066l0.05-0.068l0.001,0.135l0.254,0.32l0.917,4.288l-0.015,0.019l-0.564,0.7v2.47L25.157,26.658z M23.057,26.559h1.939 l-0.426-0.882V23.16l0.011-0.014l0.561-0.695l-0.905-4.229l-0.21-0.259l-0.21,0.259l-0.905,4.229l0.571,0.709l-0.005,2.539 L23.057,26.559z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 17.23,
    height: 0.959,
    x: 15.385,
    y: 26.568,
    fill: "#fff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M32.665,27.577H15.335v-1.059h17.329V27.577z M15.435,27.478h17.13v-0.859h-17.13V27.478z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 18.424,
    height: 0.959,
    x: 14.788,
    y: 27.456,
    fill: "#fff"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M33.262,28.465H14.738v-1.059h18.523V28.465z M14.838,28.365h18.324v-0.859H14.838V28.365z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 19.343,
    height: 0.959,
    x: 14.329,
    y: 28.344,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M33.721,29.354H14.279v-1.06h19.442V29.354z M14.378,29.254h19.243v-0.86H14.378V29.254z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 20.149,
    height: 0.959,
    x: 13.926,
    y: 29.232,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M34.125,30.241H13.875v-1.059h20.249V30.241z M13.975,30.142h20.05v-0.859h-20.05V30.142z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 0.352,
    height: 3.629,
    x: 29.323,
    y: 26.563,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M29.725,30.241h-0.452v-3.729h0.452V30.241z M29.373,30.142h0.252v-3.529h-0.252V30.142z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 0.352,
    height: 3.629,
    x: 30.288,
    y: 26.563,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M30.689,30.241h-0.452v-3.729h0.452V30.241z M30.337,30.142h0.252v-3.529h-0.252V30.142z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 0.352,
    height: 3.629,
    x: 17.35,
    y: 26.563,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M17.752,30.241H17.3v-3.729h0.452V30.241z M17.4,30.142h0.252v-3.529H17.4V30.142z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 0.352,
    height: 3.629,
    x: 18.315,
    y: 26.563,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M18.717,30.241h-0.452v-3.729h0.452V30.241z M18.364,30.142h0.253v-3.529h-0.253V30.142z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 0.352,
    height: 3.629,
    x: 23.367,
    y: 26.563,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M23.769,30.241h-0.452v-3.729h0.452V30.241z M23.417,30.142h0.252v-3.529h-0.252V30.142z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 0.352,
    height: 3.629,
    x: 24.332,
    y: 26.563,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M24.734,30.241h-0.452v-3.729h0.452V30.241z M24.381,30.142h0.253v-3.529h-0.253V30.142z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 0.367,
    height: 1.619,
    x: 26.686,
    y: 24.484,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M27.103,26.153h-0.467v-1.719h0.467V26.153z M26.735,26.054h0.268v-1.52h-0.268V26.054z"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 0.367,
    height: 1.619,
    x: 27.455,
    y: 24.484,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M27.873,26.153h-0.467v-1.719h0.467V26.153z M27.505,26.054h0.268v-1.52h-0.268V26.054z"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 0.367,
    height: 1.619,
    x: 20.186,
    y: 24.484,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M20.604,26.153h-0.467v-1.719h0.467V26.153z M20.236,26.054h0.268v-1.52h-0.268V26.054z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 0.367,
    height: 1.619,
    x: 20.956,
    y: 24.484,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M21.373,26.153h-0.467v-1.719h0.467V26.153z M21.005,26.054h0.268v-1.52h-0.268V26.054z"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 1.171,
    height: 0.1,
    x: 29.407,
    y: 22.941,
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.758,
    height: 0.1,
    x: 29.614,
    y: 22.356,
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.597,
    height: 0.1,
    x: 29.694,
    y: 21.84,
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.505,
    height: 0.1,
    x: 29.74,
    y: 21.312,
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.39,
    height: 0.1,
    x: 29.798,
    y: 20.817,
    fill: "#424242"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 1.171,
    height: 0.1,
    x: 17.465,
    y: 22.941,
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.758,
    height: 0.1,
    x: 17.671,
    y: 22.356,
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.597,
    height: 0.1,
    x: 17.752,
    y: 21.84,
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.505,
    height: 0.1,
    x: 17.798,
    y: 21.312,
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.39,
    height: 0.1,
    x: 17.855,
    y: 20.817,
    fill: "#424242"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 1.171,
    height: 0.1,
    x: 23.436,
    y: 22.253,
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.758,
    height: 0.1,
    x: 23.643,
    y: 21.392,
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.597,
    height: 0.1,
    x: 23.723,
    y: 20.632,
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.505,
    height: 0.1,
    x: 23.769,
    y: 19.855,
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.39,
    height: 0.1,
    x: 23.827,
    y: 19.13,
    fill: "#424242"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#283593",
    d: "M24,4c-6.98,0-13.117,3.581-16.695,9h33.39C37.117,7.581,30.98,4,24,4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#283593",
    d: "M24,44c6.98,0,13.117-3.581,16.695-9H7.305C10.883,40.419,17.02,44,24,44z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8CambodiaCircular);
export default __webpack_public_path__ + "static/media/icons8-cambodia-circular.44d72abec479fed8ff7ae654c3c9fd9d.svg";
export { ForwardRef as ReactComponent };